import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import axios from "axios";
import axiosInstance from '../../Shared/Utill/AxiosConfig';
import { useState, useEffect } from "react";
import { constants, environmentVariables } from "../../Shared/Url/Constants";
import { useSelector, useDispatch } from "react-redux";
import Cookie from 'js-cookie';
import dateFormat from 'dateformat';


const AvailabilityTabs = (props) => {

  const token = Cookie.get('X_TKN');
  const [weeks, setWeeks] = React.useState([]);
  const urlDetails = useSelector((state) => state.url.urlData);
  const options ={month: 'short' , timeZone: 'UTC'}
  const [value, setValue] = React.useState(props.weekOfMonth - 1);
  useEffect(() => {
    //disableFuturechk();
    if(props.baseDate!== undefined) {
      
      console.log(props.baseDate+ " plzzz")
      getWeeks(props.baseDate)
      setValue(props.weekOfMonth - 1)
      console.log("Weeks after apiCall!! "+ weeks)
    }
  
  }, [props.baseDate, props.weekOfMonth]);



  function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  /*
  This method will setWeeks with the response gained from 
  the getWeeksInMthDate call. 
  */ 
  const getWeeks = (props) => {
    console.log(props+ " Base Date")
    axiosInstance.get(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_WEEKS_IN_MONTH}/${props}`,{
      headers: {  
        'content-type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then((response) => {
     let data = JSON.stringify(response.data)
      console.log(data + "----RESPONSE")
      setWeeks(()=>{
        return response.data
      })

    }) // then

  }

 /* let response = [ 
     {
   "fscBow":"2022-10-30 00:00:00",
   "fscEow":"2022-11-05 00:00:00",
    },
     {
      "fscBow":"2022-11-06 00:00:00",
      "fscEow":"2022-11-12 00:00:00",
    },
     {
      "fscBow":"2022-11-13 00:00:00",
      "fscEow":"2022-11-19 00:00:00",
    },
     {
      "fscBow":"2022-11-20 00:00:00",
      "fscEow":"2022-11-26 00:00:00",
    },
    
  
  ]*/

   const displayDate = (date) => {
    let display = date.toDateString();
    let splitarray = display.split(" ");
    return splitarray[1] + " ";
}
  

  const formatMonth = (input) => 
  {
    
    console.log(input + " before new Date")
    console.log((input) + " new date of input")
    const test = displayDate((input))
    // (new Date(input).toLocaleString('en-US', options))
    //console.log("Checking out dateFormat " + test)
    //const s = test.toLocaleDateString('en-US', options)
    //console.log(s + "-------")
    return test
  }

  const formatDate = (input) => 
  {
    console.log(new Date(input).getUTCDate() + "-------")
    return new Date(input).getUTCDate()
  }
  

  const handleChange = (event, newValue) => {
    console.log("-----",newValue)
    setValue(newValue);
    console.log(weeks[newValue].fscBow+" BOW FOR CALLBACK")
    props.sendBOW(weeks[newValue].fscBow)
  };

  return (
    
    <Box sx={{ width: 'auto' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" 
        TabIndicatorProps={{
          style: {
            backgroundColor: "black",
          }
        }}
        textColor={
          'primary'
        }
        >
          {
            weeks.map((e)=>
          {
            return (
              <Tab label= {formatMonth(new Date(e.fscBow + " 00:00:00"))+" "+formatDate(e.fscBow) + " - " + formatMonth(new Date(e.fscEow + " 00:00:00")) +" "+ formatDate(e.fscEow) } 
              tabIndex={0} style={{padding: weeks.length > 4 ? '0px 7px': '0px 11px', minWidth: weeks.length > 4 ? "20%" : "25%"}}   />
            );
            })}
        </Tabs>
      </Box>
          

      
    </Box>
  );
}

export default AvailabilityTabs;